import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { RenderWhenReady } from 'shared/components/render-when-ready';
import { DeviceMarker } from 'console/entities/device.map.markers/ui';
import { a2l } from 'shared/map/lib/utils';
import { useAppSelector, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { async_select_ghost_location } from 'entities/device.map.track/lib/selectors';
import { useAPI } from 'console/shared/api/api-context';
import { selectDevicesFields } from 'entities/device/lib';
import { select_ui_settings } from 'console/redux/settings-actions';
import { ErrorSnack } from 'console/dialogs/error/snake-error/snake';
import { createSelector } from '@reduxjs/toolkit';
const selectDevicesColor = createSelector(selectDevicesFields(['id', 'color']), (_, device_id) => device_id, (devices, selected_device_id) => {
    return devices.find((d) => d.id === selected_device_id)?.color || '#c4443b';
});
// Полупрозрачный маркер, появляющийся при наведении на график скорости
export const DeviceGhost = memo(function DeviceGhost(props) {
    const { device_id } = props;
    const api = useAPI();
    const ghost = usePartialAppSelector(async_select_ghost_location, device_id, api);
    const ghost_color = usePartialAppSelector(selectDevicesColor, device_id);
    const ghost_size = useAppSelector((state) => select_ui_settings(state).map?.marker_size ?? 32);
    const showError = useCallback((error) => (_jsx(ErrorSnack, { error: error, open: true, sx: {
            zIndex: 401,
            position: 'absolute',
            left: 'calc(50% - 25px)',
            top: 'calc(50% - 25px)',
        } })), []);
    if (ghost == null) {
        return null;
    }
    return (_jsx(RenderWhenReady, { loaderComponent: null, promise: ghost, errorComponent: showError, clear_on_promise_change: true, children: (result) => result != null && result.loc != null ? (_jsx(DeviceMarker, { position: a2l(result.loc), prev_position: result.prevloc != null
                ? a2l(result.prevloc)
                : a2l(result.loc), color: ghost_color, icon_size: ghost_size, label_visible: false, opacity: 0.7 })) : null }));
});
